import { render } from "./StaffSmsDialog.vue?vue&type=template&id=23b764fe&scoped=true"
import script from "./StaffSmsDialog.vue?vue&type=script&lang=js"
export * from "./StaffSmsDialog.vue?vue&type=script&lang=js"

import "./StaffSmsDialog.vue?vue&type=style&index=0&id=23b764fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b764fe"]])

export default __exports__